import React from 'react'

import PrimaryHeader from '../primary-header'
import Title from '../title'
import LinkContact from './link-contact'
import ConfirmContract from '../confirm-contract'

import * as S from './styles'

import IProps from './props'

import { formatPhoneNumber } from '../../helpers/helper-format-number'
import LinkBuilder from '../../helpers/helper-link-builder'

const DoctorHeader = ({
  name,
  email,
  number,
  chatId,
  isContracted,
  handleContract,
}: IProps) => (
  <PrimaryHeader>
    <Title>Voltar</Title>
    <div>
      <S.Name>{`Dr(a). ${name}`}</S.Name>
      <S.InfoContainer>
        <LinkContact
          to={{
            pathname: LinkBuilder.buildMailtoLink(email),
          }}
          target="_blank"
          icon="email"
          label={email}
        />
        <LinkContact
          to={{
            pathname: LinkBuilder.buildWhatsAppLink(number),
          }}
          target="_blank"
          icon="whatsapp"
          label={formatPhoneNumber(number)}
          isPhone
        />
        <LinkContact
          to={`/chat/MEDICO/${chatId}`}
          icon="message"
          label="Conversar pelo chat"
        />
      </S.InfoContainer>
    </div>

    {!isContracted && <ConfirmContract handleContract={handleContract} />}
  </PrimaryHeader>
)

export default DoctorHeader
